// import React, { useState, useEffect } from "react";
// import { Modal, Button } from "react-bootstrap";
// import { FiX } from "react-icons/fi";
// import { useDispatch, useSelector } from "react-redux";
// import { updateProfile } from "../../../redux/slices/profileSlice";

// const ResumeUploadedModal = ({ show, onHide }) => {
//   const dispatch = useDispatch();
//   const store = useSelector((state) => state.profile);

//   const [selectedOption, setSelectedOption] = useState("");
//   const [error, setError] = useState("");

//   const resumeOptions = [
//     { value: "true", label: "Yes, resume uploaded" },
//     { value: "false", label: "No resume uploaded" },
//   ];

//   // Load existing value
//   useEffect(() => {
//     if (!show) return;

//     const current =
//       store?.profileItem?.data?.nurseProfile?.resume_uploaded;

//     if (current !== undefined && current !== null) {
//       setSelectedOption(String(current));
//     }
//   }, [show, store?.profileItem]);

//   const handleSelect = (value) => {
//     setSelectedOption(value);
//     setError("");
//   };

//   const handleSave = () => {
//     if (!selectedOption) {
//       setError("Please select an option");
//       return;
//     }

//     const formData = new FormData();

//     formData.append(
//       "name",
//       store?.profileItem?.data?.name ||
//         store?.profileItem?.data?.full_name ||
//         ""
//     );

//     formData.append("resume_uploaded", selectedOption);

//     dispatch(updateProfile(formData));
//   };

//   useEffect(() => {
//     if (store?.actionFlag === "PROFILE_UPDT_SCS") {
//       onHide();
//     }
//   }, [store?.actionFlag]);

//   return (
//     <Modal
//       show={show}
//       onHide={onHide}
//       centered
//       size="lg"
//       dialogClassName="custom-modal profile-other-details-modal"
//     >
//       <Modal.Header>
//         <h5 className="modal-title">
//           Have you uploaded your resume?
//         </h5>

//         <Button className="close-btn" onClick={onHide}>
//           <FiX size={24} />
//         </Button>
//       </Modal.Header>

//       <Modal.Body>
//         <div className="radio-options">
//           <div className="row">
//             {resumeOptions.map((option) => (
//               <div
//                 key={option.value}
//                 className={`radio-option col-lg-6 ${
//                   selectedOption === option.value ? "selected" : ""
//                 }`}
//                 onClick={() => handleSelect(option.value)}
//               >
//                 <div className="contentwrap">
//                   <input
//                     type="radio"
//                     checked={selectedOption === option.value}
//                     readOnly
//                   />

//                   <label className="radio-label">
//                     {option.label}
//                   </label>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>

//         {error && <div className="error-message mt-2">{error}</div>}

//         <div className="text-center mt-4">
//           <Button
//             className="btn-primary px-4"
//             onClick={handleSave}
//             disabled={store?.isLoading}
//           >
//             {store?.isLoading ? "Saving..." : "Save"}
//           </Button>
//         </div>
//       </Modal.Body>
//     </Modal>
//   );
// };

// export default ResumeUploadedModal;
import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { FiX, FiUpload, FiEye } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import {
  getViewProfile,
  updateProfile,
  uploadCrtDocument,
} from "../../../redux/slices/profileSlice";
import { jobsDocument } from "../../../redux/slices/jobsSlice";

const ResumeUploadedModal = ({
  show,
  onHide,
  value = "",
  file = null,
  onSave,
  isApplyPage = false,
  applicationId,
}) => {
  const dispatch = useDispatch();
  const store = useSelector((state) => state.profile);

  const [selectedOption, setSelectedOption] = useState("");
  const [error, setError] = useState("");
  const [resumeFile, setResumeFile] = useState(null);

  const resumeOptions = [
    { value: "true", label: "Yes, resume uploaded" },
    { value: "false", label: "No resume uploaded" },
  ];

  // useEffect(() => {
  //   if (!show) return;

  //   const current = store?.profileItem?.data?.nurseProfile?.resume_uploaded;

  //   if (current !== undefined && current !== null) {
  //     setSelectedOption(String(current));
  //   }
  // }, [show, store?.profileItem]);
  useEffect(() => {
    if (!show) return;

    if (isApplyPage) {
      setSelectedOption(value !== undefined ? String(value) : "");
      setResumeFile(file || null);
    } else {
      const current = store?.profileItem?.data?.nurseProfile?.resume_uploaded;

      if (current !== undefined && current !== null) {
        setSelectedOption(String(current));
      }
    }

    // ❗ ONLY depend on show
  }, [show]);

  const handleSelect = (value) => {
    setSelectedOption(value);
    setError("");
  };

  
// const handleResumeUpload = async (file) => {
//   if (!(file instanceof File)) return;

//   const formData = new FormData();
//   formData.append("file", file);
//   formData.append("document_type", "resume");
//   formData.append("document_name", file.name);
//   formData.append("description", "User resume");

//   if (isApplyPage) {
//     const res = await dispatch(
//       jobsDocument({
//         applicationId,
//         data: formData,
//       })
//     );

//     const uploaded = res?.payload?.data;

//     if (uploaded) {
//       setResumeFile({
//         id: uploaded.id,
//         url: uploaded.file_url || uploaded.file_path,
//       });

//       setSelectedOption("true"); // 🔥 VERY IMPORTANT
//     }
//   } else {
//     const res = await dispatch(uploadCrtDocument(formData));

//     const uploaded = res?.payload?.data;

//     if (uploaded) {
//       setResumeFile({
//         id: uploaded.id,
//         url: uploaded.file_url || uploaded.file_path,
//       });

//       setSelectedOption("true"); // 🔥 VERY IMPORTANT
//     }
//   }
// };
const handleResumeUpload = async (file) => {
  if (!(file instanceof File)) return;

  console.log("🔥 APPLY CHECK:", isApplyPage, applicationId);

  // ✅ EXTENSION VALIDATION (FIXED)
  const allowedExtensions = ["pdf", "jpg", "jpeg", "png", "doc", "docx"];
  const fileExt = file.name.split(".").pop().toLowerCase();

  if (!allowedExtensions.includes(fileExt)) {
    setError(
      "Only allowed file types: .pdf, .jpg, .jpeg, .png, .doc, .docx"
    );
    return;
  }

  setError("");

  const formData = new FormData();
  formData.append("file", file);
  formData.append("document_type", "resume");
  formData.append("document_name", file.name);
  formData.append("description", "User resume");

  try {
    if (isApplyPage && applicationId) {
      console.log("🚀 CALLING JOB DOCUMENT API");

      const res = await dispatch(
        jobsDocument({
          applicationId,
          data: formData,
        })
      ).unwrap();

      console.log("✅ RESPONSE:", res);

      setResumeFile({
        id: res?.data?.id,
        url: res?.data?.file_url || res?.data?.file_path,
      });

      setSelectedOption("true");
    } else {
      console.log("🚀 CALLING PROFILE API");

      const res = await dispatch(uploadCrtDocument(formData)).unwrap();

      setResumeFile({
        id: res?.data?.id,
        url: res?.data?.file_url || res?.data?.file_path,
      });

      setSelectedOption("true");
    }
  } catch (err) {
    console.log("❌ ERROR:", err);
    setError(err?.message || "Upload failed");
  }
};

  // const handleResumeUpload = (file) => {
  //   if (!file) {
  //     setError("Please select a file");
  //     return;
  //   }

  //   console.log("✅ File selected:", file);
  //   console.log("👉 is File object:", file instanceof File);
  //   if (isApplyPage) {
  //     // ✅ APPLY PAGE → CALL JOB API
  //     const formData = new FormData();

  //     formData.append("file", file);
  //     formData.append("document_type", "resume");
  //     formData.append("document_name", file.name);
  //     formData.append("description", "User resume");

  //     dispatch(
  //       jobsDocument({
  //         applicationId,
  //         data: formData,
  //       }),
  //     ).then((res) => {
  //       const uploaded = res?.payload?.data;

  //       if (uploaded) {
  //         setResumeFile({
  //           id: uploaded.id,
  //           url: uploaded.file_url || uploaded.file_path,
  //         });
  //       }
  //     });

  //     return;
  //   }

  //   // ✅ PROFILE PAGE (existing)
  //   const formData = new FormData();
  //   formData.append("file", file);
  //   formData.append("document_type", "resume");
  //   formData.append("document_name", "resume");
  //   formData.append("description", "User resume");

  //   dispatch(uploadCrtDocument(formData)).then((res) => {
  //     const filePath = res?.payload?.data?.file_path;

  //     if (filePath) {
  //       const fileUrl = `${process.env.REACT_APP_API_BASE_URL}/uploads/resume/${filePath}`;

  //       setResumeFile({
  //         id: filePath,
  //         url: fileUrl,
  //       });
  //     }
  //   });
  // };
  // const handleSave = () => {
  //   if (!selectedOption) {
  //     setError("Please select an option");
  //     return;
  //   }

  //   if (selectedOption === "true" && !resumeFile) {
  //     setError("Upload resume first or select No");
  //     return;
  //   }

  //   const formData = new FormData();

  //   formData.append(
  //     "name",
  //     store?.profileItem?.data?.name ||
  //       store?.profileItem?.data?.full_name ||
  //       "",
  //   );

  //   formData.append("resume_uploaded", selectedOption);

  //   dispatch(updateProfile(formData));
  // };
  const handleSave = () => {
    if (!selectedOption) {
      setError("Please select an option");
      return;
    }

    const finalValue = selectedOption === "true";

    if (finalValue && !resumeFile) {
      setError("Upload resume first or select No");
      return;
    }

    if (isApplyPage) {
      // ✅ LOCAL
      onSave(finalValue, resumeFile);
      onHide();
    } else {
      // ✅ API
      const formData = new FormData();

      formData.append(
        "name",
        store?.profileItem?.data?.name ||
          store?.profileItem?.data?.full_name ||
          "",
      );

      formData.append("resume_uploaded", finalValue);

      dispatch(updateProfile(formData));
    }
  };
  // useEffect(() => {
  //   const docs = store?.profileItem?.data?.documents;

  //   if (!docs) return;

  //   const resumeDoc = docs.find((doc) => doc.document_type === "resume");

  //   if (resumeDoc) {
  //     const fileUrl = `${process.env.REACT_APP_API_BASE_URL}/uploads/resume/${resumeDoc.file_path}`;

  //     setResumeFile({
  //       id: resumeDoc.id,
  //       url: fileUrl,
  //     });
  //   }
  // }, [store?.profileItem]);
  useEffect(() => {
    if (isApplyPage) return;

    const docs = store?.profileItem?.data?.documents;
    if (!docs) return;

    const resumeDoc = docs.find((doc) => doc.document_type === "resume");

    if (resumeDoc) {
      const fileUrl = `${process.env.REACT_APP_API_BASE_URL}/uploads/resume/${resumeDoc.file_path}`;

      setResumeFile({
        id: resumeDoc.id,
        url: fileUrl,
      });
    }
  }, [store?.profileItem, isApplyPage]);

  useEffect(() => {
    if (store?.actionFlag === "PROFILE_UPDT_SCS") {
      onHide();
    }
  }, [store?.actionFlag]);
  useEffect(() => {
    if (show) {
      // dispatch(getViewProfile());
    }
  }, [show, dispatch]);
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="lg"
      dialogClassName="custom-modal profile-other-details-modal"
    >
      <Modal.Header>
        <h5 className="modal-title">Have you uploaded your resume?</h5>

        <Button className="close-btn" onClick={onHide}>
          <FiX size={24} />
        </Button>
      </Modal.Header>

      <Modal.Body>
        <div className="radio-options">
          <div className="row">
            {resumeOptions.map((option) => (
              <div
                key={option.value}
                className={`radio-option col-lg-6 ${
                  selectedOption === option.value ? "selected" : ""
                }`}
                onClick={() => handleSelect(option.value)}
              >
                <div className="contentwrap d-flex justify-content-between align-items-center">
                  <div>
                    <input
                      type="radio"
                      checked={selectedOption === option.value}
                      readOnly
                    />

                    <label className="radio-label">{option.label}</label>
                  </div>

                  {/* Upload icons */}
                  {option.value === "true" && selectedOption === "true" && (
                    <div
                      className="d-flex align-items-center gap-2"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <label style={{ cursor: "pointer" }}>
                        <FiUpload size={18} />

                        <input
                          type="file"
                          hidden
                          // onChange={(e) =>
                          //   handleResumeUpload(e.target.files[0])
                          // }
                          onChange={(e) => {
                            const file = e.target.files?.[0];

                            if (!file) {
                              console.log("❌ No file selected");
                              return;
                            }

                            handleResumeUpload(file);
                          }}
                        />
                      </label>

                      {resumeFile?.url && (
                        <a
                          href={resumeFile.url}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <FiEye size={18} />
                        </a>
                      )}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        {error && <div className="error-message mt-2">{error}</div>}

        <div className="text-center mt-4">
          <Button
            className="btn-primary px-4"
            onClick={handleSave}
            disabled={
              store?.isLoading ||
              !selectedOption ||
              (selectedOption === "true" && !resumeFile)
            }
          >
            {store?.isLoading ? "Saving..." : "Save"}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ResumeUploadedModal;
